import React from 'react';
import { useMaestroStore } from '../../store/maestroStore';
import { useTranslation } from '../../i18n/useTranslation';

/**
 * True when the Connector's volume self-check found that no volume route changes the
 * active player's level (renderer `volume_not_controllable`). Falls back to the zone in
 * discoveredZones when a partial zone object sits in activeZone.
 */
export function useVolumeNotControllable() {
  return useMaestroStore((s) => {
    const active = s.discovery?.activeZone;
    if (active?.capabilities?.volumeNotControllable) return true;
    if (!active?.id) return false;
    const match = (s.discovery?.discoveredZones || []).find((z) => z.id === active.id);
    return !!match?.capabilities?.volumeNotControllable;
  });
}

/** Shown instead of the volume slider for fixed-volume players. */
export default function FixedVolumeBadge() {
  const { t } = useTranslation();
  const notControllable = useVolumeNotControllable();
  if (notControllable) {
    const note = t('volume_set_on_player');
    return (
      <div className="flex items-center gap-1.5 opacity-60" style={{ color: 'var(--text-tertiary)' }} role="note" aria-disabled="true" data-testid="volume-not-controllable" title={note}>
        <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
          <path d="M3 9V15H7L12 20V4L7 9H3Z" />
        </svg>
        <span className="text-[10px] font-medium leading-tight" style={{ maxWidth: 150 }}>{note}</span>
      </div>
    );
  }
  return (
    <div className="flex items-center gap-1.5" style={{ color: 'var(--text-tertiary)' }}>
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
        <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
        <path d="M7 11V7a5 5 0 0 1 10 0v4" />
      </svg>
      <span className="text-[10px] font-medium whitespace-nowrap">Fixed Volume</span>
    </div>
  );
}
